import {
    BOOK_TENANT_REQUEST,
    BOOK_TENANT_SUCCESS,
    BOOK_TENANT_FAILURE,
    RESE_BOOK_TENANT_SUCCESS
  } from '../../../Constants/actionTypes';


  import { API_BOOK_TENENT } from '../../../Constants/apiUrls'


  export const resetOnSuccessBookingTenant = () => ({
    type: 'RESE_BOOK_TENANT_SUCCESS'
  });



// Helper function to handle errors
const handleErrors = async (response) => {
  if (!response.ok) {
    const errorText = await response.text();
    try {
      const errorJson = JSON.parse(errorText);
      return errorJson.error || 'Unknown Error'; // Return the error message
    } catch (e) {
      return errorText || 'Unknown Error'; // Return the error text if JSON parsing fails
    }
  }
  return null; // No error
};

  export const bookTenant = (bookingDetails) => async (dispatch, getState) => {
    dispatch({ type: BOOK_TENANT_REQUEST });

    // Retrieve access token from the state
    const state = getState();
    const accessToken = state.auth.accessToken;
  
    try {
      const response = await fetch(API_BOOK_TENENT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
        body: JSON.stringify(bookingDetails),
      });
  
      const errorMessage = await handleErrors(response); // Check for errors

      if (errorMessage) {
        throw new Error(errorMessage); // Throw an error with the actual error message
      }

      const data = await response.json();
  
      dispatch({
        type: BOOK_TENANT_SUCCESS,
        payload: data,
      });
    } catch (error) {
      let errorMessage;
      if (error.message === 'Failed to fetch' || error.message.includes('NetworkError')) {
        errorMessage = 'Server is currently down. Please try again later.';
      } else {
        errorMessage = error.message;
      }
      dispatch({
        type: BOOK_TENANT_FAILURE,
        payload: errorMessage,
      });
    }
  };